import { axiosApi } from './helper'

export function getBuilding(id) {
  return axiosApi('buildings/' + id, {}, 'get')
}

export function getBuildingsBySearch(search) {
  return axiosApi('buildings/search', { value: search }, 'get')
}
